import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import ChangeEmailPage from '@/settings/pages/change-email';

export const Route = createFileRoute('/settings/_layout/user-profile/change-email')({
  head: () => ({
    meta: routeMetadata('Change Email')
  }),
  component: ChangeEmailRoute,
  staticData: {
    headerSection: null
  }
});

function ChangeEmailRoute() {
  return <ChangeEmailPage/>;
}
